<template>
  <nav class="pagination" :class="{'is-right':!reverse}" role="navigation" aria-label="pagination" v-if="totalPage > 1">
    <a class="pagination-previous" @click.prevent.stop="goPage(currentPage - 1)"
       :disabled="currentPage <= 1">
      <i class="fal fa-arrow-left"></i>
    </a>
    <ul class="pagination-list" :class="{'has-items-right':reverse}">
      <li v-for="(n, i) in buttons" :class="{'active' : n == currentPage}" :key="i">
        <a v-if="currentPage === n" class="pagination-link is-current" :aria-label="'Page ' + n" aria-current="page">
          {{ n }}</a>
        <span v-else-if="n === '...'" class="pagination-ellipsis">&hellip;</span>
        <a @click.prevent.stop="goPage(n)" class="pagination-link" :aria-label="'Aller à la page ' + n" 
            :style="loading ? 'cursor: not-allowed' : ''" v-else>
          {{ n }}</a>
      </li>
    </ul>
    <a class="pagination-next" @click.prevent.stop="goPage(currentPage + 1)" :disabled="currentPage >= totalPage">
      <i class="fal fa-arrow-right"></i>
    </a>
  </nav>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      currentPage: {
        type: Number,
        required: false,
        default: 0
      },
      totalPage: {
        type: Number,
        required: false,
        default: 0
      },
      maxDisplay: {
        type: Number,
        required: false,
        default: 2
      },
      reverse: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      buttons () {
        let l
        let left = this.currentPage - this.maxDisplay
        let right = this.currentPage + this.maxDisplay + 1
        const tmp = []
        const res = []
        for (let i = 1; i <= this.totalPage; i++) {
          if (i === 1 || i === this.totalPage || (i >= left && i < right)) {
            tmp.push(i)
          }
        }

        for (let i of tmp) {
          if (l) {
            if (i - l === 2) {
              res.push(l + 1)
            } else if (i - l !== 1) {
              res.push('...')
            }
          }
          res.push(i)
          l = i
        }
        return res
      }
    },
    methods: {
      goPage (p) {
        if (this.loading || p < 1 || p > this.totalPage) {
          return
        }
        this.update(p)
      },
      update (p) {
        this.$emit('ChangePage', p)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/Pagination.vue